import { ActionIcon, Box, Flex } from '@mantine/core';
import React, { useEffect, useRef, useState } from 'react'
import { BsPrinter } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import ExportExcel from '../../ExportExcel';
import { GoInfo } from 'react-icons/go';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import ModalDetailLokasiVisit from '../../Modal/ModalDetailLokasiVisit';
import { useMediaQuery } from 'react-responsive';

function TabVisitInKaryawanPrint({
    visitIn,
    karyawanid,
    userDetail,
}) {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const navigate = useNavigate();

    const printAbsensi = () => {
        navigate("/visit-masuk/" + karyawanid);
    }

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (visitIn && visitIn.length > 0) {
            const dataTableFilter = visitIn.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {
                    const dateParts = data?.visitIn_time.split('T')[0].split('-');
                    const year = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const day = Number(dateParts[2]);

                    return {
                        ...data,
                        date: new Date(year, month, day),
                    };
                })
            );
        }
    }, [visitIn]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const cellDate = new Date(cellValue.getFullYear(), cellValue.getMonth(), cellValue.getDate());

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const [showDetailLokasiVisit, setShowDetailLokasiVisit] = useState(false);
    const [rowSelected, setRowSelected] = useState()
    const handleShowModal = (row) => {
        setShowDetailLokasiVisit(true);
        setRowSelected(row)
    }

    const colDefs = [
        {
            field: "detail",
            headerName: 'Detail',
            width: 120,
            pinned: 'left',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowModal(row?.data)}
                    >
                        <GoInfo
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
        {
            field: "date",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            filterParams: filterParams,
            sort: 'desc',
            valueFormatter: (params) => {
                const date = params.value;
                if (date instanceof Date && !isNaN(date)) {
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                }
                return '';
            }
        },
        {
            field: "jam",
            headerName: 'Jam',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visitIn_time.split('T')[1].split('.')[0]}
                    </div>
                );
            },
        },
        {
            field: "visitIn_place",
            headerName: 'Lokasi',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.visitIn_place}
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const gridRef = useRef(null);

    const handleExportRowsExcelData = () => {
        if (!gridRef.current) return [];

        const filteredRows = [];
        gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            if (node.data) {
                filteredRows.push(node.data);
            }
        });

        const excelData = filteredRows.map((row) => ({
            'Visit Masuk': row.visitIn_time,
            'Lokasi Visit Masuk': row.visitIn_place,
        }));
        return excelData;
    };

    return (
        <Box>
            {/* Top Toolbar */}
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                }}
            >
                <Flex gap="xs" align="center">
                    <ActionIcon onClick={printAbsensi}>
                        <BsPrinter style={{ backgroundColor: 'transparent', color: '#222' }} size={40} />
                    </ActionIcon>
                    <ActionIcon>
                        <ExportExcel
                            getExcelData={handleExportRowsExcelData}
                            fileName={`Data Visit Masuk ${userDetail?.first_name} ${userDetail?.last_name}`}
                        />
                    </ActionIcon>
                </Flex>
            </Box>
            <div style={{ height: 500 }}>

                <AgGridReact
                    theme={themeLightCold}
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    pagination={isMobile ? false : true}
                    rowHeight={25}
                />

            </div>

            <ModalDetailLokasiVisit
                rowSelected={rowSelected}
                showDetailLokasiVisit={showDetailLokasiVisit}
                setShowDetailLokasiVisit={setShowDetailLokasiVisit}
            />
        </Box>
    )
}

export default TabVisitInKaryawanPrint
